import { render, staticRenderFns } from "./UpdateReferralCode.vue?vue&type=template&id=fb761e7a"
import script from "./UpdateReferralCode.vue?vue&type=script&lang=js"
export * from "./UpdateReferralCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports